import { useState } from "react";
import Part1 from "../../BAccount/parts/tabsI/part1";
import Part3 from "../../BAccount/parts/tabsI/part3";

const Eidentification = () => {
  const [wow, setWow] = useState(0);
  const Show = [Part1, Part3];
  const Dis = Show[wow];
  return (
    <div className="">
      <div className="flex mt-8 mb-[5rem]">
        <button
          onClick={() => setWow(0)}
          className={` ${
            wow === 0 ? "bg-primary text-white" : "bg-[#EDEDED]"
          } flex p-2 rounded-xl flex items-center justify-center  mr-2 min-w-[5.5rem] pl-4 pr-4 relative mt-5`}
        >
          IDs / Certificates
          <div
            className={`${
              wow === 0 ? "" : "hidden"
            } arrow-down absolute right-[35%] bottom-[-38%]`}
          ></div>
        </button>
        <button
          onClick={() => setWow(1)}
          className={`${
            wow === 1 ? "bg-primary text-white" : "bg-[#EDEDED]"
          } flex p-2 rounded-xl flex items-center justify-center  mr-2 min-w-[5.5rem] pl-4 pr-4 relative mt-5`}
        >
            Tax Information
          <div
            className={`${
              wow === 1 ? "" : "hidden"
            } arrow-down absolute right-[35%] bottom-[-38%]`}
          ></div>
        </button>

       
      </div>
      <Dis />
    </div>
  );
};

export default Eidentification;
